import Abstract from "./../abstract-view/abstract.js";

import {
  createElement
} from "./../render/render.js";

import {PictureDefault} from "./const.js";

const createPictureTemplate = (
    {
      src,
      width,
      height,
      classes,
      sources,
      resolutions,
      dirname,
      filename,
      extension
    }) => {

  const aspectratio = (width && height) ? `data-aspectratio="${width / height}"` : ``;
  const pictureClasses = classes.picture ? ` class="${classes.picture.join(` `)}"` : ``;
  const sourcesMarkup = [];
  const widthMarkup = width ? `width="${width}"` : ``;

  sources.forEach((source) => {
    const srcSetItems = [];

    Object.entries(resolutions).forEach(([type, name]) => {
      srcSetItems.push(dirname + filename + name + `.` + source + ` ` + type);
    });

    sourcesMarkup.push(
        `<source
          data-srcset="${srcSetItems.join(`,\n`)}"

          ${aspectratio}

          srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          type="image/${source}">`
    );
  });

  const srcSetMarkup = [];

  Object.entries(resolutions).forEach(([type, name]) => {
    srcSetMarkup.push(dirname + filename + name + `.` + extension + ` ` + type);
  });

  const imagesClasses = classes.image ? `${classes.image.join(` `)} ` : ``;

  return (
    `<picture${pictureClasses}>
      ${sourcesMarkup.join(`\n`)}

      <img
        class="${imagesClasses}lazyload"

        alt=""
        ${widthMarkup}

        src="${src}"
        srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="

        data-srcset="${srcSetMarkup.join(`,\n`)}"
        data-src="${src}"

        ${aspectratio}
      >
    </picture>`
  );
};

export default class Picture extends Abstract {
  constructor({
    src,
    width,
    height,
    classes,
    sources,
    resolutions
  }) {
    super();

    this._src = src;
    this._width = width;
    this._height = height;
    this._classes = classes || PictureDefault.CLASSES;
    this._sources = sources || PictureDefault.SOURCES;
    this._resolutions = resolutions || PictureDefault.RESOLUTIONS;

    this._dirname = null;
    this._filename = null;
    this._extension = null;

    this._setSrcParams();
  }

  getTemplate() {
    return createPictureTemplate({
      src: this._src,
      width: this._width,
      height: this._height,
      classes: this._classes,
      sources: this._sources,
      resolutions: this._resolutions,
      dirname: this._dirname,
      filename: this._filename,
      extension: this._extension
    });
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this.getTemplate());
    }

    return this._element;
  }

  getImage() {
    if (!this._element) {
      this._element = createElement(this.getTemplate());
    }

    return this._element.querySelector(`img`);
  }

  _setSrcParams() {
    const fileParts = this._src.split(`/`).reverse();

    const basename = fileParts[0];
    const basenameParts = basename.split(`.`);

    this._filename = basenameParts[0];
    this._extension = basenameParts[1];
    this._dirname = this._src.replace(basename, ``);
  }
}
